<h1 mat-dialog-title >{{ 'MODAL/accept_mdr_return/title' | translate }}</h1>
<div mat-dialog-actions>
   <textarea matInput [placeholder]="'MODAL/accept_mdr_return/placeholder'|translate" [(ngModel)]="valueRe"></textarea>
   <div class="d-flex justify-content-between w-100">
      <button mat-button [mat-dialog-close]="[true,valueRe]" cdkFocusInitial >{{ 'Confirm' | translate }}</button>
      <button mat-button [mat-dialog-close]="[false]" cdkFocusInitial >{{ 'Cancel' | translate }}</button>
   </div>
</div>
